module.exports = __webpack_public_path__ + "static/media/17-2.67fb93df.mp3";